import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { SearchResultSectionLink } from '@atlassian/search-dialog';
import { messages } from '../../messages';
import { useQuery } from '../query-context';
import { useAnalytics } from '../../common/analytics';
import { onSearchResultViewAllLinkClicked } from '../../common/analytics/events';
export var ViewAllLink = function ViewAllLink(_ref) {
  var linkComponent = _ref.linkComponent,
    section = _ref.section,
    _ref$totalResults = _ref.totalResults,
    totalResults = _ref$totalResults === void 0 ? 0 : _ref$totalResults;
  var _useQuery = useQuery(),
    query = _useQuery.query;
  var _useAnalytics = useAnalytics(),
    fireAnalyticsEvent = _useAnalytics.fireAnalyticsEvent;
  var viewAllLinkGenerator = section.viewAllLinkGenerator,
    viewAllLinkRenderer = section.viewAllLinkRenderer;
  if (!viewAllLinkGenerator) {
    return null;
  }
  return (
    /*#__PURE__*/
    // eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    React.createElement("div", {
      onClick: function onClick() {
        fireAnalyticsEvent(onSearchResultViewAllLinkClicked(section.id));
      },
      role: "none"
    }, /*#__PURE__*/React.createElement(SearchResultSectionLink, {
      linkComponent: linkComponent,
      href: viewAllLinkGenerator(query),
      testId: "search-result-section-link"
    }, viewAllLinkRenderer ? viewAllLinkRenderer({
      section: section,
      totalResults: totalResults
    }) : /*#__PURE__*/React.createElement(FormattedMessage, messages.common_show_all_results_link)))
  );
};